/* eslint-disable import/no-anonymous-default-export */

// add some color to the albedo based on the dot product

export default /* glsl */`

// had trouble with this struct thing
struct TpmData {
	bool useTpmMap;
	bool useTpmNormalMap;
    bool useTpmMetalnessMap;
    bool useTpmRoughnessMap;
    bool useTpmEmissiveMap;

    bool tilt;

    // vec2 mapTpmScale; // no idea why these didn't work
    // vec2 normalTpmScale;
    // vec2 metalnessTpmScale;
    // vec2 roughnessTpmScale;
    // vec2 emissiveTpmScale;
};

uniform TpmData tpmData;

uniform vec2 mapTpmScale;
uniform vec2 normalTpmScale;
uniform vec2 metalnessTpmScale;
uniform vec2 roughnessTpmScale;
uniform vec2 emissiveTpmScale;

vec4 triplanar_mapping( sampler2D texInput, vec3 normal, vec3 position, vec2 scale ) {

    vec3 bf = normalize( abs( normal ) );
    bf /= dot( bf, vec3( 1.0 ) );

    // scale = 1.0 / scale; // tested this because scale didn't work at one point
    vec2 tx;
    vec2 tz;
    if (tpmData.tilt){
        tx = vec2(position.y * scale.x, position.z * scale.y);
        tz = vec2(position.y * scale.x, position.x * scale.y);
    } else {
        tx = vec2(position.z * scale.x, position.y * scale.y);
        tz = vec2(position.x * scale.x, position.y * scale.y);
    }
    
    vec2 ty = vec2(position.z * scale.x, position.x * scale.y);
    vec4 cx = texture2D(texInput, tx).rgba * bf.x;
    vec4 cy = texture2D(texInput, ty).rgba * bf.y;
    vec4 cz = texture2D(texInput, tz).rgba * bf.z; 

    return cx + cy + cz;
}
`;